"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Player = _interopRequireDefault(require("./Player"));
var _target = _interopRequireDefault(require("cccisd-icons/target2"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = {
  code: 'section',
  name: 'Section',
  icon: /*#__PURE__*/_react["default"].createElement(_target["default"], null),
  player: _Player["default"],
  isAdult: true,
  isStaticPlayer: true,
  skipPlaying: true,
  previewButtons: ['delete']
};